import { clsx } from 'clsx'

export default function TabletHeader({ title, role, unit, teal = false }) {
  return (
    <div className={clsx(
      'flex items-center justify-between px-4 py-2.5 rounded-t-2xl -mx-0',
      teal ? 'bg-teal-600' : 'bg-brand-600'
    )}>
      <div>
        <p className="text-white text-sm font-medium leading-tight">{title}</p>
        <p className="text-white/70 text-[11px] mt-0.5">{role}</p>
      </div>
      <span className={clsx(
        'text-white/80 text-[11px] px-2.5 py-1 rounded-full',
        teal ? 'bg-teal-700' : 'bg-brand-700'
      )}>
        {unit}
      </span>
    </div>
  )
}
